import { Grid2 as Grid, Avatar, Box, Dialog, DialogTitle, IconButton, DialogContent, Paper, useMediaQuery, Alert } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import { Close } from '@mui/icons-material';

interface CourseViewerProps {
    isCourseViewerOpen: boolean;
    closeCourseViewer: () => void;
    courseTitle: string;
    courseLink: string;
    courseNote: string;
}

const CourseViewer = (props:CourseViewerProps): JSX.Element => {

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
      });
      
    const frameHeight = isMd ? '480px' : '400px';

    return (
        <>
            <Dialog
                open={props.isCourseViewerOpen}
                onClose={props.closeCourseViewer}
                scroll={'paper'}
                maxWidth={'md'}
                fullWidth={true}
                keepMounted
                sx={{
                    "& .MuiDialog-container": {
                        justifyContent: "center",
                        alignItems: "center",
                    }
                }}
                PaperProps={{
                    sx: {
                        m: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        minHeight: '85vh'
                    }
                }}
            >
            <DialogTitle> Course for {props.courseTitle}</DialogTitle>
                <IconButton
                aria-label="close"
                onClick={props.closeCourseViewer}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                 }}
            >
                    <Close />
                </IconButton>
                <DialogContent dividers sx={{ height: '80%' }}>
                    {
                        props.courseNote &&
                        <Alert severity="warning">
                            <div dangerouslySetInnerHTML={{ __html: props.courseNote }} />
                        </Alert>
                    }
                    <Box component={Paper} marginTop={2}>
                        <iframe 
                            src={props.courseLink} width="100%" height={frameHeight}
                        />
                    </Box>
                </DialogContent>
            </Dialog>

        </>
    );
  };


export default CourseViewer;